import restApi from "@plannel/services/utils/rest-api";

/*
 * Inventory Dashboard(재고 현황) 데이터 서비스.
 * 독립 DW 기반 백엔드 조회.
 *   백엔드: GET /api/dashboard-dw/inventory (InventoryDashboardController)
 *   소스: z_mv_fact_inventory_actual_month / z_mv_fact_sales_actual_month / z_fact_ip_inventory / z_fact_inventory_actual
 * 참고: saas-application/docs/sql/dw/DASHBOARD_GUIDE.md §7
 *
 * 응답 envelope: { currencyCd, period, locations, locId, itemLevels, itemLevel, itemGrouped,
 *                  invTrend:{AMT,QTY}, salesTrend:{AMT,QTY}, doiTrend,
 *                  shortageRows[], excessRows[], slowStock[], deadStock:{pie, byLoc:{AMT,PCT}} }
 *
 * ★ 품목 계층 레벨(itemLevel)은 **품절·과잉 경고 둘에만** 걸린다 — 추이 3장은 전 품목 합이고
 *   부진·불용 재고는 aging 버킷·거점 축이라 레벨과 무관하다.
 *   itemGrouped=true 면 경고 행의 품목 컬럼(itemCd/itemNm/abc)이 itemGrp 한 컬럼으로 바뀐다.
 */
const get = (params) => restApi.get("/api/dashboard-dw/inventory", { params });

const inventoryService = { get };

export default inventoryService;
